import Http from "@/commons/Http";

export default {
    getByLivro(livro) {
        return Http.get(`/api/lna-srei/livro/${livro}`);
    }
}
